/** Unidad de volumen en PDF Invoice PTC (Quantity + resumen). */
export const VOLUME_UNITS_PTC = ['M3', 'CBM'];

export function normalizeVolumeUnitPtc(value) {
  const u = String(value || 'M3')
    .trim()
    .toUpperCase()
    .replace(/\u00B3/g, '3')
    .replace(/\s+/g, '');
  return u === 'CBM' ? 'CBM' : 'M3';
}

export function formatQtyWithVolumeUnit(qty, unit, formatNumber) {
  if (qty == null || qty === '' || Number.isNaN(Number(qty))) return '';
  const formatted = formatNumber(Number(qty), 3);
  return `${formatted} ${normalizeVolumeUnitPtc(unit)}`;
}

export function totalVolumeSummaryText(totalBundles, totalM3, unit, formatNumber) {
  const u = normalizeVolumeUnitPtc(unit);
  const bundles =
    totalBundles != null && totalBundles !== '' && !Number.isNaN(Number(totalBundles))
      ? formatNumber(Number(totalBundles), 0)
      : '';
  const vol =
    totalM3 != null && totalM3 !== '' && !Number.isNaN(Number(totalM3))
      ? formatNumber(Number(totalM3), 3)
      : '';
  return `Total bundles: ${bundles}  |  Total ${u}: ${vol}`;
}
